<template>
  <v-container fluid>
    <back-link-component :to="{ name: 'RefLineListAsList' }" :label="$tt('customRefLine')" />
    <h2>{{ $tt('customRefLineAddTitle') }}</h2>
    <div>
      <v-row>
        <v-col cols="12" sm="6">
          <v-card class="flexcard" height="100%" outlined>
            <v-card-title>{{ $tt('customRefLineImportTitle') }}</v-card-title>
            <v-card-text class="text--primary">{{ $tt('customRefLineImportText') }}</v-card-text>
            <v-card-text class="text--primary">{{ $tt('customRefLineImportText2') }}</v-card-text>
            <v-card-text class="grow">
              <v-card class="mx-3 mb-3 pa-3" outlined>
                <v-card-text class="text--primary">
                  <p>{{ $tt('customFileUploadShapefileDescriptionForRefLines') }}</p>
                  <ul class="mb-4">
                    <li>{{ $tt('customFileUploadShpDescriptionForRefLines') }}</li>
                    <li>{{ $tt('customFileUploadShxDescriptionForRefLines') }}</li>
                    <li>{{ $tt('customFileUploadDbfDescriptionForRefLines') }}</li>
                  </ul>
                </v-card-text>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-btn block color="primary" :to="{ name: 'RefLineImport' }">{{ $tt('customUpload') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card class="flexcard" height="100%" outlined>
            <v-card-title>{{ $tt('customRefLineCreateTitle') }}</v-card-title>
            <v-card-text class="text--primary">{{ $tt('customRefLineCreateText') }}</v-card-text>
            <v-card-text class="grow"> </v-card-text>
            <v-card-actions>
              <v-btn block color="primary" disabled>
                Comming soon
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import RefLineMixin from '@/components/mixins/ref-line-mixin'

export default {
  name: 'RefLineAdd',
  mixins: [RefLineMixin],
  mounted() {
    this.checkAvailabilityBeforeMount()
  },
}
</script>

<style scoped>
.flexcard {
  display: flex;
  flex-direction: column;
}
</style>
